import React from 'react'
import { useTranslation } from '@mc/i18n'
import { BannerContent } from '../../../../components/Banner/BannerContent'
import { BannerPromoText } from '../../../../components/Banner/BannerPromoText'
import { UrgencyText } from '../../../../components/featureVariables'
import { Pen7565BannerTitleWrapper } from '../../../pen-7565_v1_promo_banner_200_classes'
import { Pen7584BannerTitleWrapper } from '../../../pen-7584_v1_promo_banner_all_classes'
import { PLAN_Z_FREE_GIFT_I18N_NAMESPACE } from '../../i18n'

interface BannerRedesignProps {
  hideCta?: boolean
  ctaHref: string
  onCtaClick: () => void
  ctaCopy: string
}

export const BannerRedesign = (props: BannerRedesignProps) => (
  <>
    <Desktop {...props} />
    <Mobile {...props} />
  </>
)

const Desktop = ({
  hideCta,
  ctaHref,
  onCtaClick,
  ctaCopy,
}: BannerRedesignProps) => {
  const { t } = useTranslation(PLAN_Z_FREE_GIFT_I18N_NAMESPACE)

  return (
    <div className='d-none d-md-flex flex-1 justify-content-between align-items-end mc-py-4 mc-py-md-0'>
      <div className='d-flex flex-column mc-mr-md-10'>
        <BannerContent.Title>
          <p className='text-left'>
            <Pen7584BannerTitleWrapper
              control={
                <Pen7565BannerTitleWrapper
                  control={<BannerPromoText />}
                  keepWidth={false}
                />
              }
              keepWidth={false}
            />
          </p>
        </BannerContent.Title>

        <p className='mc-text-x-small text-left mc-opacity--hinted mc-pl-1 mc-p-md-0 mc-mt-2'>
          {t('freeGift.banner')}
        </p>
      </div>
      <div className='d-flex flex-column align-items-center justify-content-between mc-text--nowrap'>
        {hideCta ? null : (
          <BannerContent.CTA ctaHref={ctaHref} onCtaClick={onCtaClick}>
            {ctaCopy}
          </BannerContent.CTA>
        )}

        {/* replica of BannerContent.Subtitle */}
        <>
          <div className='mc-text-x-small mc-opacity--hinted'>
            {/* Tablet & Desktop */}
            <div className='d-none d-md-block'>
              <p className='mc-mr-4 d-inline-flex'>
                <UrgencyText />
              </p>
            </div>

            {/* Mobile */}
            <div className='d-block d-md-none'>
              <p className='d-block mc-text--center mc-mt-3'>
                <UrgencyText />
              </p>
            </div>
          </div>
        </>
      </div>
    </div>
  )
}

const Mobile = ({
  hideCta,
  ctaHref,
  onCtaClick,
  ctaCopy,
}: BannerRedesignProps) => {
  const { t } = useTranslation(PLAN_Z_FREE_GIFT_I18N_NAMESPACE)

  return (
    <div className='d-md-none d-flex flex-1 flex-column justify-content-between align-items-center'>
      {/* replica of BannerContent.Subtitle */}
      {/* Mobile */}
      <p className='mc-text--center mc-text-h8 mc-opacity--hinted mc-text--uppercase mc-mb-2'>
        <UrgencyText />
      </p>

      <BannerContent.Title>
        <Pen7584BannerTitleWrapper
          control={<Pen7565BannerTitleWrapper control={<BannerPromoText />} />}
        />
      </BannerContent.Title>

      <p className='mc-text-x-small mc-opacity--hinted mc-text--center mc-mt-2'>
        {t('freeGift.banner')}
      </p>

      {hideCta ? null : (
        <BannerContent.CTA ctaHref={ctaHref} onCtaClick={onCtaClick}>
          {ctaCopy}
        </BannerContent.CTA>
      )}
    </div>
  )
}
